import React from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    TimeScale,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import "chartjs-adapter-moment";
import moment from "moment";
import { converteParaHorarioLocal } from "../utils/utils";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    TimeScale,
    Title,
    Tooltip,
    Legend
);

export default function GraficoUmidade({ dataEstacao, date }) {
    const options = {
        radius: 1, // desabilitar pontos
        locale: 'pt-br',
        responsive: true,
        scales: {
            x: {
                grid: {
                    display: false,
                },
                type: "time",
                time: {
                    unit: "hour",
                    displayFormats: {
                        hour: "HH:00",
                    },
                },
                min: moment(new Date(date.year, date.month - 1, date.day, 5, 0, 0)),
                max: moment(new Date(date.year, date.month - 1, date.day, 20, 0, 0)),
            },
            y: {
                title: {
                    display: true,
                    text: "Umidade (%)",
                },
            },
            A: {
                position: "right",
                title: {
                    display: true,
                    text: "Pluviômetro (mm)",
                },
            },
        },
        tension: 0.4,
    };

    const data = {
        labels: dataEstacao?.map((g) => converteParaHorarioLocal(g.data)),
        datasets: [
            {
                label: "Umidade",
                yAxisID: "y",
                data: dataEstacao?.map((g) => g.umidade),
                borderColor: "rgb(0, 153, 153)",
                backgroundColor: " rgb(0, 153, 153, 0.5)",
            },
            {
                label: "Pluviômetro (dia)",
                yAxisID: "A",
                data: dataEstacao?.map((g) => g?.pluviometro_acumulado_dia),
                borderColor: "rgb(53, 162, 235)",
                backgroundColor: "rgba(53, 162, 235, 0.5)"
            },
            {
                label: "Pluviômetro (hora)",
                yAxisID: "A",
                data: dataEstacao?.map((g) => g?.pluviometro_acumulado_hora),
                borderColor: "rgb(28, 44, 196)",
                backgroundColor: "rgb(28, 44, 196, 0.5)",
            },
            {
                label: "Pluviômetro (minuto)",
                yAxisID: "A",
                data: dataEstacao?.map((g) => g?.pluviometro_acumulado_minuto),
                borderColor: "rgb(102, 102, 255)",
                backgroundColor: "rgb(102, 102, 255, 0.5)",
            },
        ],
    };

    return <Line options={options} data={data} />;
}
